document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-combo-sale]').forEach((section) => {
    const discountTwo = parseFloat(section.dataset.discountTwo || '0.25');
    const discountThree = parseFloat(section.dataset.discountThree || '0.3');
    const promoCode = section.dataset.promoCode || '';
    const slots = Array.from(section.querySelectorAll('[data-combo-slot]'));
    const selections = new Array(slots.length).fill(null);

    const totalPriceEl = section.querySelector('[data-total-price]');
    const saveRowEl = section.querySelector('[data-save-row]');
    const saveAmountEl = section.querySelector('[data-save-amount]');
    const originalPriceEl = section.querySelector('[data-original-price]');
    const promoRowEl = section.querySelector('[data-promo-row]');
    const promoDividerEl = section.querySelector('[data-promo-divider]');
    const cartBtn = section.querySelector('.combo-cart-btn');
    const checkoutBtn = section.querySelector('.combo-checkout-btn');
    const productsArea = section.querySelector('[data-combo-products]');

    const parsePrice = (priceText) => {
      let cleaned = String(priceText).replace(/[^0-9.,]/g, '');
      const dotCount = (cleaned.match(/\./g) || []).length;
      const commaCount = (cleaned.match(/,/g) || []).length;

      if (commaCount > 0) {
        if (dotCount === 0) {
          const lastCommaIndex = cleaned.lastIndexOf(',');
          cleaned = `${cleaned.substring(0, lastCommaIndex)}.${cleaned.substring(lastCommaIndex + 1)}`;
          cleaned = cleaned.replace(/,/g, '');
        } else {
          cleaned = cleaned.replace(/,/g, '');
        }
      }

      cleaned = cleaned.replace(/\.(?=.*\.)/g, '');
      return Number(cleaned) || 0;
    };

    const decimalOperation = (a, b, operation = 'add', precision = 2) => {
      const factor = 10 ** precision;
      const fixedA = Math.round(Number(a) * factor);
      const fixedB = Math.round(Number(b) * factor);

      if (operation === 'subtract') {
        return (fixedA - fixedB) / factor;
      }

      return (fixedA + fixedB) / factor;
    };

    const formatPrice = (price) =>
      price.toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });

    const getCurrencySign = (formattedPrice) =>
      String(formattedPrice).replace(/[a-zA-Z0-9.,\s]/g, '').trim() || '$';

    const formatMoney = (amount, currencySign) => {
      let formatted = `${currencySign}${formatPrice(amount)}`;
      if (currencySign === '€') {
        formatted = formatted.replace('.', ',');
      }
      return formatted;
    };

    const toSpeechMoney = (amount, currencySign) => {
      const number =
        currencySign === '€'
          ? formatPrice(amount).replace('.', ',')
          : formatPrice(amount);

      if (currencySign === '€') return `${number} euros`;
      if (currencySign === '£') return `${number} pounds`;
      return `${number} US dollars`;
    };

    const totalSummaryEl = section.querySelector('[data-bundle-total-summary]');

    const updateTotalSpeechLabel = ({
      totalAmount,
      saveAmount,
      originalAmount,
      currencySign,
      withSave,
    }) => {
      if (!totalSummaryEl) return;

      if (totalAmount == null) {
        totalSummaryEl.removeAttribute('aria-label');
        return;
      }

      let label = `Bundle total price ${toSpeechMoney(totalAmount, currencySign)}.`;
      if (withSave && saveAmount != null && originalAmount != null) {
        label += ` Save ${toSpeechMoney(saveAmount, currencySign)}. Original total price ${toSpeechMoney(originalAmount, currencySign)}.`;
      }
      totalSummaryEl.setAttribute('aria-label', label);
    };

    const getFilledCount = () => selections.filter(Boolean).length;

    const getFirstEmptyIndex = () => selections.findIndex((item) => !item);

    const renderSlots = () => {
      slots.forEach((slotEl, index) => {
        const product = selections[index];
        const imageEl = slotEl.querySelector('.anniversary-combo-sale__slot-image');
        const titleEl = slotEl.querySelector('.anniversary-combo-sale__slot-title');
        const priceEl = slotEl.querySelector('.anniversary-combo-sale__slot-price');

        if (product) {
          slotEl.classList.add('is-filled');
          slotEl.classList.remove('is-guide');
          imageEl.src = product.image;
          imageEl.alt = product.title || 'Bundle product';
          imageEl.removeAttribute('aria-hidden');
          titleEl.textContent = product.title;
          titleEl.hidden = false;
          priceEl.textContent = product.priceFormatted;
          priceEl.hidden = false;
        } else {
          slotEl.classList.remove('is-filled');
          slotEl.classList.add('is-guide');
          imageEl.removeAttribute('src');
          imageEl.alt = '';
          imageEl.setAttribute('aria-hidden', 'true');
          titleEl.textContent = '';
          titleEl.hidden = true;
          priceEl.textContent = '';
          priceEl.hidden = true;
        }
      });
    };

    const togglePromoRow = (visible) => {
      if (promoRowEl) promoRowEl.classList.toggle('is-active', visible);
      if (promoDividerEl) promoDividerEl.classList.toggle('is-active', visible);
    };

    const updateCheckout = () => {
      const filled = selections.filter(Boolean);
      const count = filled.length;

      if (!totalPriceEl) return;

      if (count === 0) {
        totalPriceEl.textContent = '';
        if (saveRowEl) saveRowEl.hidden = true;
        updateTotalSpeechLabel({ totalAmount: null });
        togglePromoRow(false);
        setButtonsDisabled(true);
        return;
      }

      const currencySign = getCurrencySign(filled[0].priceFormatted);
      const priceTotal = filled.reduce((sum, item) => sum + item.price, 0);

      if (count === 1) {
        totalPriceEl.textContent = filled[0].priceFormatted;
        if (saveRowEl) saveRowEl.hidden = true;
        updateTotalSpeechLabel({
          totalAmount: filled[0].price,
          currencySign,
          withSave: false,
        });
        togglePromoRow(false);
        setButtonsDisabled(true);
        return;
      }

      const discountRate = count >= 3 ? 1 - discountThree : 1 - discountTwo;
      const finalTotal = priceTotal * discountRate;
      const saveAmount = decimalOperation(priceTotal, finalTotal, 'subtract');

      totalPriceEl.textContent = formatMoney(finalTotal, currencySign);

      if (saveRowEl && saveAmountEl && originalPriceEl) {
        saveRowEl.hidden = false;
        saveAmountEl.textContent = formatMoney(saveAmount, currencySign);
        originalPriceEl.textContent = formatMoney(priceTotal, currencySign);
      }

      updateTotalSpeechLabel({
        totalAmount: finalTotal,
        saveAmount,
        originalAmount: priceTotal,
        currencySign,
        withSave: true,
      });

      togglePromoRow(Boolean(promoCode));

      const variantIds = filled.map((item) => item.variantId).join(',');
      setButtonsDisabled(false, variantIds);
    };

    const setButtonsDisabled = (disabled, variantIds = '') => {
      [cartBtn, checkoutBtn].forEach((btn) => {
        if (!btn) return;
        btn.classList.toggle('forbid', disabled);
        if (disabled) {
          btn.removeAttribute('data-variant-id');
        } else if (btn.classList.contains('combo-cart-btn')) {
          btn.setAttribute('data-variant-id', variantIds);
        }
      });
    };

    const addProduct = (product) => {
      const emptyIndex = getFirstEmptyIndex();
      if (emptyIndex === -1) return false;

      selections[emptyIndex] = product;
      renderSlots();
      updateCheckout();
      return true;
    };

    const removeProduct = (index) => {
      selections[index] = null;
      renderSlots();
      updateCheckout();
    };

    section.querySelectorAll('[data-remove-bundle]').forEach((btn) => {
      btn.addEventListener('click', () => {
        const slotEl = btn.closest('[data-combo-slot]');
        if (!slotEl) return;
        removeProduct(Number(slotEl.dataset.comboSlot));
      });
    });

    const scrollToBuilder = () => {
      if (!section.getBoundingClientRect) return;
      window.scrollTo({
        top: window.scrollY + section.getBoundingClientRect().top - 80,
        behavior: 'smooth',
      });
    };

    const getProductFromBundleBtn = (btn) => {
      const modal = btn.closest('quick-add-modal');

      if (modal) {
        const variantInput = modal.querySelector('.product-variant-id');
        const priceContainer = modal.querySelector('.price__container');
        const mediaImg = modal.querySelector('.product__media img');
        const priceFormatted =
          priceContainer?.getAttribute('max-price') ||
          priceContainer?.getAttribute('price') ||
          btn.getAttribute('price') ||
          '';

        return {
          variantId: variantInput?.value || btn.getAttribute('bundle-id') || '',
          title: btn.getAttribute('title') || btn.dataset.title || '',
          price: parsePrice(priceFormatted),
          priceFormatted,
          image: mediaImg?.getAttribute('src') || btn.getAttribute('img') || '',
        };
      }

      return {
        variantId: btn.dataset.variantId,
        title: btn.dataset.title,
        price: Number(btn.dataset.price) / 100 || parsePrice(btn.dataset.priceFormatted),
        priceFormatted: btn.dataset.priceFormatted,
        image: btn.dataset.image,
      };
    };

    const handleBundleClick = (btn) => {
      if (btn.classList.contains('disabled') || btn.hasAttribute('disabled')) return;

      const product = getProductFromBundleBtn(btn);
      if (!product.variantId) return;

      const added = addProduct(product);
      if (!added) return;

      const modal = btn.closest('quick-add-modal');
      if (modal) {
        const closeBtn = modal.querySelector('.quick-add-modal__toggle');
        if (closeBtn) closeBtn.click();
      }

      scrollToBuilder();
    };

    // Card buttons live in the section; modal buttons are injected into quick-add-modal.
    section.addEventListener('click', (event) => {
      const btn = event.target.closest('.bundle-btn');
      if (!btn || !section.contains(btn)) return;
      handleBundleClick(btn);
    });

    document.addEventListener('click', (event) => {
      const btn = event.target.closest('.bundle-btn');
      if (!btn) return;

      const modal = btn.closest('quick-add-modal.quick-add-modal--combo');
      if (!modal) return;

      // Only handle combo modals opened from this section's product cards.
      const openerModalId = modal.id;
      if (!openerModalId || !section.querySelector(`[data-modal="#${openerModalId}"]`)) return;

      handleBundleClick(btn);
    });

    document.addEventListener('click', (event) => {
      const variantInput = event.target.closest(
        'quick-add-modal.quick-add-modal--combo .product-variant-list input'
      );
      if (!variantInput) return;

      const modal = variantInput.closest('quick-add-modal');
      if (!modal || !section.querySelector(`[data-modal="#${modal.id}"]`)) return;

      const comboBtn = modal.querySelector('.combo-pro-btn');
      if (!comboBtn) return;

      comboBtn.classList.toggle('disabled', variantInput.classList.contains('disabled'));
    });

    section.querySelectorAll('[data-scroll-to-products]').forEach((btn) => {
      btn.addEventListener('click', () => {
        if (!productsArea) return;
        productsArea.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });

    const copyToClip = (content) => {
      const aux = document.createElement('input');
      aux.setAttribute('value', content);
      document.body.appendChild(aux);
      aux.select();
      document.execCommand('copy');
      document.body.removeChild(aux);
    };

    const copyBtn = section.querySelector('[data-copy-promo]');
    if (copyBtn) {
      copyBtn.addEventListener('click', () => {
        const codeEl = section.querySelector('.anniversary-combo-sale__promo-code');
        if (!codeEl) return;

        copyToClip(codeEl.textContent.trim());
        copyBtn.classList.add('active');
        setTimeout(() => copyBtn.classList.remove('active'), 3000);
      });
    }

    if (checkoutBtn && cartBtn) {
      checkoutBtn.addEventListener('click', () => {
        if (checkoutBtn.classList.contains('forbid')) return;

        const spinner = checkoutBtn.querySelector('.loading__spinner');
        if (spinner) spinner.classList.remove('hidden');

        cartBtn.click();

        const drawer = document.querySelector('.drawer');
        if (drawer) drawer.style.display = 'none';

        setTimeout(() => {
          const drawerBtn = document.querySelector('.cart-drawer .cart__checkout-button');
          if (drawerBtn) drawerBtn.click();
        }, 2500);
      });
    }

    const tabs = section.querySelectorAll('[data-combo-tabs] .anniversary-combo-sale__tab');
    const panels = section.querySelectorAll('.anniversary-combo-sale__panel');

    tabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        const index = tab.dataset.tabIndex;

        tabs.forEach((item) => {
          const isActive = item === tab;
          item.classList.toggle('is-active', isActive);
          item.setAttribute('aria-selected', isActive ? 'true' : 'false');
        });

        panels.forEach((panel) => {
          panel.classList.toggle('is-active', panel.dataset.panelIndex === index);
        });

        const activePanel = section.querySelector(`.anniversary-combo-sale__panel[data-panel-index="${index}"]`);
        const swiperEl = activePanel?.querySelector('[data-combo-swiper]');
        if (swiperEl?.swiper) {
          swiperEl.swiper.update();
        }
      });
    });

    section.querySelectorAll('[data-combo-swiper]').forEach((swiperEl) => {
      const panel = swiperEl.closest('.anniversary-combo-sale__panel');
      const swiperWrap = swiperEl.closest('.anniversary-combo-sale__swiper-wrap');
      const paginationEl = panel?.querySelector('.anniversary-combo-sale__pagination');

      new Swiper(swiperEl, {
        slidesPerView: 2,
        spaceBetween: 8,
        observer: true,
        observeParents: true,
        pagination: {
          el: paginationEl,
          clickable: true,
        },
        navigation: {
          nextEl: swiperWrap?.querySelector('.swiper-button-next'),
          prevEl: swiperWrap?.querySelector('.swiper-button-prev'),
        },
        breakpoints: {
          770: {
            slidesPerView: 4,
            spaceBetween: 24,
          },
        },
      });
    });

    renderSlots();
    updateCheckout();
  });
});
